import { render, staticRenderFns } from "./Logic.vue?vue&type=template&id=31a854aa&scoped=true"
import script from "./Logic.vue?vue&type=script&lang=js"
export * from "./Logic.vue?vue&type=script&lang=js"
import style0 from "./Logic.vue?vue&type=style&index=0&id=31a854aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a854aa",
  null
  
)

export default component.exports